import React from 'react';

import { PageTitle } from '../../Text';

export default () => (
  <div className="primary-content">
    <PageTitle>
      Mailing Address
    </PageTitle>
    <p>
      Please select a mailing address from the options below:
    </p>
  </div>
);
